module.exports = __webpack_public_path__ + "static/media/orderDetailsPlusIcon.3fd6a9dc.svg";